import React from 'react';
import { Button } from 'eehc-library';
import Result from 'antd/es/result';
import 'antd/es/result/style';
import i18next from 'i18next';
import styles from './ErrorFallback.module.scss';

export default function ErrorFallback({ onRetry, hideReloadBtn }) {
  return (
    <div className={styles['error-container']}>
      <Result
        className={styles.result}
        status="error"
        title={i18next.t('error')}
        subTitle={i18next.t('error-extend')}
      />
      <div>
        <Button type="primary" onClick={(() => onRetry())}>{i18next.t('retry')}</Button>
        {hideReloadBtn ? null : <Button className={styles.homeBtn} href="/">{i18next.t('home')}</Button>}
      </div>
    </div>
  );
}
